<p-table styleClass="p-datatable-striped" [value]="personalQueueData"
    [globalFilterFields]="['agentName','customerName', 'transactionType','displayUpdatedDate','status']"
    (sortFunction)="myAssignmentsCustomSort($event, personalQueueData)" [customSort]="true" #dt #myAssignmentTable>
    <ng-template pTemplate="caption">
        <div class="row">
            <div class="col-sm-6 col-md-3">
                <input class="mvd_form-control" type="text" pInputText size="50" placeholder="Filter Results..."
                    (input)="dt.filterGlobal($event.target.value, 'contains')">
            </div>
        </div>
    </ng-template>
    <ng-template pTemplate="header">
        <tr>
            <th [pSortableColumn]="'agentName'">Agent<p-sortIcon [field]="'agentName'"></p-sortIcon>
            </th>
            <th [pSortableColumn]="'customerName'">Customer Name<p-sortIcon [field]="'customerName'"></p-sortIcon>
            </th>
            <th [pSortableColumn]="'transactionType'">Service<p-sortIcon [field]="'transactionType'"></p-sortIcon>
            </th>
            <th [pSortableColumn]="'displayUpdatedDate'">Date/Time<p-sortIcon [field]="'displayUpdatedDate'">
                </p-sortIcon>
            </th>
            <th [pSortableColumn]="'status'">Status<p-sortIcon [field]="'status'"></p-sortIcon>
            </th>
            <th class="w--actions-3">Actions</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-businessTransaction let-rowIndex>
        <tr>
            <td>{{businessTransaction.agentName}}</td>
            <td>{{businessTransaction.customerName}}</td>
            <td><a href="javascript:void(0)"
                    (click)="redirectToMyTransaction(businessTransaction)">{{businessTransaction.transactionType}}</a>
            </td>
            <td>{{businessTransaction.displayUpdatedDate}}</td>
            <td>{{businessTransaction.status}}</td>
            <td>
                <service-icons
                    [businessTransactionId]="+businessTransaction.transactionId"
                    [showServiceIcons]="businessTransaction.statusTypeId === wipStatuses.Active.id || businessTransaction.statusTypeId === wipStatuses.Inactive.id"
                    (onHold)="holdTransaction($event)"
                    (onRemove)="removeTransaction($event)"
                    (onUnassign)="unassignTransaction($event)">
                </service-icons>
            </td>
        </tr>
    </ng-template>
</p-table>